//link and components
import React from "react"
import SongsHome from "../Components/songshome"
import TheNavbar from "../Components/navbar"
import Footer from "../Components/footer"
import Imageslider from "../Components/imageslider"
import BlogShowInHome from "../Components/blogshowinhome"
import Suggestions from "../Components/musicHome/suggestions"
//styles
import "../Styles/index.scss"
import "bootstrap/dist/css/bootstrap.min.css"
import { library } from "../../node_modules/@fortawesome/fontawesome-svg-core"



const IndexPage = props => {
  return (
    <>
      <div className="app">
        <TheNavbar></TheNavbar>
        <div className="the-home-container" style={{ marginRight: "7vw", marginLeft: "7vw" , paddingRight: "7vw", paddingLeft: "7vw" }}>
          <Imageslider />
        <SongsHome />
        

</div>
<div style={{ marginRight: "7vw", marginLeft: "7vw"}}>
<BlogShowInHome />
</div>
        
        <div className="the-home-container" style={{ marginRight: "7vw", marginLeft: "7vw" , paddingRight: "7vw", paddingLeft: "7vw" }}>
        <br/>
          <Suggestions/>
        </div>
        
        <Footer></Footer>
      </div>
    </>
  )
}

export default IndexPage
